export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/staff/updateStaffInfo',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allStaff'],
    })
